export const NICKNAME_MAX_LENGTH = 5;
export const LETTER_TITLE_MAX_LENGTH = 12;
export const RECEIVER_MAX_LENGTH = 12;
export const LETTER_CONTENT_MIN_LENGTH = 1;
export const LETTER_CONTENT_MAX_LENGTH = 30;
export const LETTER_CONTENT_WRITE_MAX_LENGTH = 40;
export const USER_WITHDRAW_REASON_MAX_LENGTH = 100;
export const LETTER_WRITE_DONE_DIALOG_SHOW_TIME = 5_000;
